import React from "react";
import { Navigate, RouteObject, useRoutes } from "react-router-dom";
import TheLayout from "./components/containers/TheLayout";
import BaseRoutes from "./components/dummy/base/routes";
import ButtonRoutes from "./components/dummy/buttons/routes";
import FormRoutes from "./components/dummy/forms/routes";
import IconRoutes from "./components/dummy/icons/routes";
import NotificationRoutes from "./components/dummy/notifications/routes";
import ThemeRoutes from "./components/dummy/theme/routes";
import AccountSettingRoutes from "./components/modules/AccountSetting/routes";
import { RequireAuth } from "./components/modules/auth/RequireAuth";
import ChatRoutes from "./components/modules/Chat/routes";
import PermissionsManagementRoutes from "./components/modules/SystemSetting/PermissionGroup/routes";
import UsersManagementRoutes from "./components/modules/UserManagement/routes";
import BanksManagementRoutes from "./components/modules/BankManagement/routes";
import WebRoutes, { webLayout } from "./components/modules/web/routes";
import { RequireAuthAdmin } from "./components/modules/auth/RequireAuthAdmin";
import LevelManagementRoutes from "./components/modules/LevelManagement/routes";
import ProductManagementRoutes from "./components/modules/ProductManagement/routes";
import OrderManagementRoutes from "./components/modules/OrderManagement/routes";
import InjectionManagementRoutes from "./components/modules/InjectionManagement/routes";
import TransactionManagement from "./components/modules/TransactionManagement/TransactionManagement";
import TheLayoutWeb from "./components/modules/web/TheLayoutWeb";
import SettingsManagement from "./components/modules/SettingsManagement/SettingsManagement";

const Table = React.lazy(() => import("./components/dummy/Table"));
const ForgotPassword = React.lazy(
  () => import("./components/modules/auth/ForgotPassword")
);
const ResetPassword = React.lazy(
  () => import("./components/modules/auth/ResetPassword")
);
const Login = React.lazy(() => import("./components/modules/auth/Login"));
const LoginAdmin = React.lazy(
  () => import("./components/modules/auth/LoginAdmin")
);
const Register = React.lazy(() => import("./components/modules/auth/Register"));
const ResetSuccess = React.lazy(
  () => import("./components/modules/auth/ResetSuccess")
);

const Dashboard = React.lazy(
  () => import("./components/dummy/dashboard/Dashboard")
);

const Charts = React.lazy(() => import("./components/dummy/charts/Charts"));
const Widgets = React.lazy(() => import("./components/dummy/widgets/Widgets"));
// Error pages

const Page404 = React.lazy(() => import("./components/modules/Page404"));
const Page500 = React.lazy(() => import("./components/modules/Page500"));
const Page403 = React.lazy(() => import("./components/modules/Page403"));

const DummyBackOfficeHome = () => <div>Home Page</div>;

const settingRoutes: RouteObject[] = [
  { path: "permissions/*", element: <PermissionsManagementRoutes /> },
];

const privateRoutes: RouteObject[] = [
  { path: "", element: <DummyBackOfficeHome /> },
  { path: "account/*", element: <AccountSettingRoutes /> },
  { path: "table", element: <Table /> },
  { path: "dashboard", element: <Dashboard /> },
  { path: "theme/*", element: <ThemeRoutes /> },
  { path: "base/*", element: <BaseRoutes /> },
  { path: "buttons/*", element: <ButtonRoutes /> },
  { path: "charts", element: <Charts /> },
  { path: "forms/*", element: <FormRoutes /> },
  { path: "icons/*", element: <IconRoutes /> },
  { path: "notifications/*", element: <NotificationRoutes /> },
  { path: "widgets", element: <Widgets /> },
  // {
  //   path: "settings/*",
  //   children: settingRoutes,
  //   caseSensitive: true,
  // },
  { path: "message/*", element: <ChatRoutes /> },
  { path: "users/*", element: <UsersManagementRoutes /> },
  { path: "bank/*", element: <BanksManagementRoutes /> },
  { path: "level/*", element: <LevelManagementRoutes /> },
  { path: "product/*", element: <ProductManagementRoutes /> },
  { path: "order/*", element: <OrderManagementRoutes /> },
  { path: "injection/*", element: <InjectionManagementRoutes /> },
  { path: 'transaction', element: <TransactionManagement /> },
  { path: 'settings', element: <SettingsManagement /> },
  // { path: '*', element: <Navigate to="/404" replace /> },
];

const privateRoutes1: RouteObject[] = [
  { path: "*", element: <WebRoutes /> },
]

const publicRoutes: RouteObject[] = [
  {
    path: "/admin/*",
    element: (
      <RequireAuthAdmin>
        <TheLayout />
      </RequireAuthAdmin>
    ),
    children: privateRoutes,
    caseSensitive: true,
  },
  {
    path: "/*",
    element: (
      <RequireAuth>
        <TheLayoutWeb />
      </RequireAuth>
    ),
    children: privateRoutes1,
    caseSensitive: true,
  },
  { path: "/404", element: <Page404 /> },
  { path: "/500", element: <Page500 /> },
  { path: "/403", element: <Page403 /> },
  { path: "/admin/login", element: <LoginAdmin /> },
  { path: "/login", element: <Login /> },
  { path: "/register", element: <Register /> },
  { path: "/forgot", element: <ForgotPassword /> },
  { path: "/reset", element: <ResetPassword /> },
  { path: "/reset-success", element: <ResetSuccess /> },
  // { path: '/auth/*', element: <AuthRoutes /> },
  { path: "*", element: <Navigate to="/404" replace /> },
];

const RouteRender = () => useRoutes(publicRoutes);

// const BackOfficeRender = () => useRoutes(backOffice);

// const BackOfficeRender = () => {
//   const { location } = useRouter();

//   const { user } = useSelector((state: RootState) => state.authentication);

//   const routes = useRoutes(
//     Boolean(user)
//       ? backOffice
//       : [{ path: '*', element: <Navigate to="/auth/login" state={{ path: location.pathname }} /> }]
//   );
//   return routes;
// };

export { RouteRender, privateRoutes, publicRoutes };
